module.exports = __webpack_public_path__ + "img/celeron.9b63337d.jpg";